import { Check } from 'lucide-react';
import { createElement } from 'react';

import { cn } from '@/lib/cn';

import { CATEGORY_ICON_KEYS, categoryIcon } from './icons';

export const SWATCH_COLORS = [
  '#6366F1', '#0EA5E9', '#8B5CF6', '#EC4899',
  '#F97316', '#EAB308', '#22C55E', '#14B8A6',
  '#EF4444', '#64748B',
];

export function ColorPicker({
  label,
  value,
  onChange,
  colors = SWATCH_COLORS,
}: {
  label?: string;
  value: string;
  onChange: (color: string) => void;
  colors?: string[];
}) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && <span className="text-[13px] font-medium text-muted">{label}</span>}
      <div className="flex flex-wrap gap-2">
        {colors.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => onChange(color)}
            aria-label={`Colour ${color}`}
            aria-pressed={color === value}
            className={cn(
              'inline-flex size-8 items-center justify-center rounded-full transition hover:scale-110',
              color === value && 'ring-2 ring-current ring-offset-2 ring-offset-surface'
            )}
            style={{ backgroundColor: color, color }}
          >
            {color === value && <Check size={15} className="text-white" strokeWidth={3} />}
          </button>
        ))}
      </div>
    </div>
  );
}

export function IconPicker({
  label,
  value,
  onChange,
  tint,
}: {
  label?: string;
  value: string;
  onChange: (icon: string) => void;
  tint: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && <span className="text-[13px] font-medium text-muted">{label}</span>}
      <div className="flex flex-wrap gap-1.5">
        {CATEGORY_ICON_KEYS.map((key) => {
          const selected = key === value;

          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              aria-label={`Icon ${key}`}
              aria-pressed={selected}
              className={cn(
                'inline-flex size-9 items-center justify-center rounded-xl border transition',
                selected ? 'border-current' : 'border-transparent hover:bg-elevated'
              )}
              style={{
                color: selected ? tint : undefined,
                backgroundColor: selected ? `${tint}1f` : undefined,
              }}
            >
              {createElement(categoryIcon(key), {
                size: 17,
                className: selected ? undefined : 'text-muted',
              })}
            </button>
          );
        })}
      </div>
    </div>
  );
}
